import type { ReactNode } from 'react';
import styles from './Keycap.module.css';

// macOS-style keycap: defined border, 1px bottom shadow for "lift," and medium
// weight text. Shared between the help dialog's row display and the
// ShortcutCaptureInput's token rendering so the chip visual is consistent.
type KeycapProps = {
  children: ReactNode;
  /** Highlight as a search match (mirrors Vapor's Shortcut `isSearch`). */
  $isSearch?: boolean;
  /**
   * Lift the keycap to its hover surface — used when the enclosing dialog row
   * is hovered so the keycap doesn't blend into the row highlight. Explicit
   * prop (rather than inherited CSS) so the contract is visible on the API.
   */
  $isHovered?: boolean;
};

export function Keycap({ children, $isSearch, $isHovered }: KeycapProps) {
  const className = [
    styles.keycap,
    $isHovered ? styles.keycapHovered : '',
    $isSearch ? styles.keycapSearch : '',
  ]
    .filter(Boolean)
    .join(' ');
  return <kbd className={className}>{children}</kbd>;
}
